(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudie-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rudie-bundle-builder')) {
    customElements.define('rudie-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        this.items = new Map();
        this.currency = this.dataset.currency || 'AUD';
        this.cards = [...this.querySelectorAll('.rbb__card')];
        this.cards.forEach((card) => {
          const select = card.querySelector('.rbb__select');
          const slides = [...card.querySelectorAll('[data-gallery-slide]')];
          const showSlide = (nextIndex) => {
            if (!slides.length) return;
            const index = (nextIndex + slides.length) % slides.length;
            slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
            card.querySelector('.rbb__gallery')?.setAttribute('data-gallery-index', index);
            const count = card.querySelector('.rbb__gallery-count b');
            if (count) count.textContent = index + 1;
          };
          card.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
            const current = Number(card.querySelector('.rbb__gallery')?.dataset.galleryIndex || 0);
            showSlide(current - 1);
          });
          card.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
            const current = Number(card.querySelector('.rbb__gallery')?.dataset.galleryIndex || 0);
            showSlide(current + 1);
          });
          const sizeDialog = card.querySelector('.rbb__dialog');
          card.querySelector('[data-size-open]')?.addEventListener('click', () => sizeDialog?.showModal());
          card.querySelector('[data-size-close]')?.addEventListener('click', () => sizeDialog?.close());
          sizeDialog?.addEventListener('click', (event) => {
            if (event.target === sizeDialog) sizeDialog.close();
          });
          select.addEventListener('change', () => {
            card.querySelector('.rbb__card-error').textContent = '';
            this.updateCard(card);
          });
          card.querySelectorAll('.rbb__quantity').forEach((button) => {
            button.addEventListener('click', () => this.changeQuantity(card, button.dataset.action === 'plus' ? 1 : -1));
          });
        });
        this.querySelector('.rbb__chips').addEventListener('click', (event) => {
          const remove = event.target.closest('[data-remove]');
          if (!remove) return;
          this.items.delete(remove.dataset.remove);
          this.render();
        });
        this.querySelector('.rbb__add').addEventListener('click', () => this.addToCart());
        const trustBar = this.querySelector('.rbb__trust');
        if (trustBar && 'IntersectionObserver' in window) {
          this.footerObserver = new IntersectionObserver((entries) => {
            this.querySelector('.rbb__bar').classList.toggle('is-hidden', entries[0].isIntersecting);
          }, { threshold: 0.05 });
          this.footerObserver.observe(trustBar);
        }
        this.render();
      }

      changeQuantity(card, change) {
        const select = card.querySelector('.rbb__select');
        if (!select.value) {
          card.querySelector('.rbb__card-error').textContent = 'Choose a size first.';
          select.focus();
          return;
        }
        const option = select.selectedOptions[0];
        const key = select.value;
        const current = this.items.get(key);
        const quantity = Math.max(0, (current?.quantity || 0) + change);
        if (quantity === 0) {
          this.items.delete(key);
        } else {
          this.items.set(key, {
            id: Number(key),
            quantity,
            product: option.dataset.product,
            variant: option.dataset.variant,
            price: Number(option.dataset.price),
            image: option.dataset.image,
            handle: card.dataset.productHandle
          });
        }
        this.render();
      }

      updateCard(card) {
        const select = card.querySelector('.rbb__select');
        card.querySelector('.rbb__quantity-value').textContent = this.items.get(select.value)?.quantity || 0;
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      tier(count) {
        if (count >= 5) return { discount: 20, message: '20% unlocked. Maximum bundle savings!' };
        if (count >= 3) return { discount: 15, message: `15% unlocked. Add ${5 - count} more for 20% off.` };
        return { discount: 0, message: `Add ${3 - count} more to save 15%.` };
      }

      render() {
        const values = [...this.items.values()];
        const count = values.reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = values.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const tier = this.tier(count);
        const total = values.reduce((sum, item) => sum + Math.round(item.price * (100 - tier.discount) / 100) * item.quantity, 0);
        this.style.setProperty('--progress', `${Math.min(count / 5 * 100, 100)}%`);
        this.querySelectorAll('[data-tier]').forEach((item) => item.classList.toggle('is-active', count >= Number(item.dataset.tier)));
        this.querySelectorAll('[data-point]').forEach((item) => item.classList.toggle('is-active', count >= Number(item.dataset.point)));
        this.querySelector('.rbb__progress-message').textContent = tier.message;
        this.querySelector('.rbb__bar-message').textContent = tier.message;
        this.querySelector('.rbb__count').textContent = count;
        this.cards.forEach((card) => {
          const productCount = values.filter((item) => item.handle === card.dataset.productHandle).reduce((sum, item) => sum + item.quantity, 0);
          card.classList.toggle('is-selected', productCount > 0);
          card.querySelector('.rbb__product-count').textContent = productCount;
          this.updateCard(card);
        });
        const chips = this.querySelector('.rbb__chips');
        chips.innerHTML = values.length ? values.map((item) => `
          <div class="rbb__chip">
            <img src="${item.image}" width="42" height="42" alt="">
            <div><strong>${item.product}</strong><span>${item.variant} · ×${item.quantity}</span></div>
            <button type="button" data-remove="${item.id}" aria-label="Remove ${item.product}, ${item.variant}">×</button>
          </div>`).join('') : '<span class="rbb__empty">Your selected styles will appear here.</span>';
        const oldTotal = this.querySelector('.rbb__total s');
        oldTotal.hidden = tier.discount === 0;
        oldTotal.textContent = this.formatMoney(subtotal);
        this.querySelector('.rbb__total strong').textContent = this.formatMoney(total);
        const button = this.querySelector('.rbb__add');
        button.disabled = count === 0;
        button.textContent = count ? `Add ${count} item${count === 1 ? '' : 's'} to cart` : 'Add bundle to cart';
      }

      async addToCart() {
        const button = this.querySelector('.rbb__add');
        if (!this.items.size || button.classList.contains('is-loading')) return;
        button.classList.add('is-loading');
        button.disabled = true;
        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [...this.items.values()].map((item) => ({ id: item.id, quantity: item.quantity, properties: { '_Bundle': 'Build Your Rudie Bundle' } })) })
          });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.href = this.dataset.cartUrl;
        } catch (error) {
          button.classList.remove('is-loading');
          button.disabled = false;
          button.textContent = 'Try adding your bundle again';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
